export const configEnv = {
  /**
   * Air-gapped build. Set by `--mode airgapped` (see .env.airgapped).
   *
   * A device on a customer's private network can reach neither Google nor
   * Firebase, so email/password and OAuth sign-in cannot work there — they
   * fail with a network error that looks like the product is broken. In this
   * mode the UI offers passkeys instead, which the API already supports
   * locally.
   */
  airgapped: import.meta.env.VITE_AIRGAPPED === '1',
  clientID: import.meta.env.VITE_CLIENT_ID || 'default',
  clientName: import.meta.env.VITE_COMPANY_NAME || 'AirPlate',
  clientLogo: import.meta.env.VITE_LOGO_URL || '/images/AirPlate-Logo.svg',
  // On a successful /subscribe, hand off to this URL (the marketing service
  // page shows the confirmation message + visual). Set VITE_SUBSCRIBE_SUCCESS_URL
  // to an empty string to keep the inline confirmation instead.
  subscribeSuccessUrl: (import.meta.env.VITE_SUBSCRIBE_SUCCESS_URL ??
    'https://airplate.dk/droneDetectionService') as string,
} as const;

export type ConfigEnv = typeof configEnv;